import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { PathPickMarketPriceBasis } from "@/features/pathpick/types";

interface Props {
  value: PathPickMarketPriceBasis;
  onChange: (basis: PathPickMarketPriceBasis) => void;
}

/**
 * 비교 기준(입찰가/거래가) 선택기 — 크림·포이즌 양쪽에 같이 적용된다.
 *
 * 운영 화면(상품 찾기 헤더 · 담은 상품 헤더 · 사이즈별 재고 모달)에 같은 블록이 인라인으로
 * 세 번 적혀 있고 추출된 컴포넌트가 없다. 가이드에서 그 세 곳을 건드리지 않으려고
 * 같은 모양을 여기서 다시 만든다 — 라벨은 같은 i18n 키를 써서 문구가 갈리지 않게 한다.
 */
function PathPickStartGuideMarketBasisSelector({ value, onChange }: Props) {
  const { t } = useI18nHelper();

  return (
    <Flex
      role={"group"}
      aria-label={t("path_pick_guide:product_tour.basis_group_aria_label")}
      gap={"4px"}
      alignItems={"center"}
      flexWrap={"wrap"}
    >
      <Text
        textStyle={"body-sm-bold"}
        color={"#444440"}
        marginRight={"4px"}
        flexShrink={0}
      >
        {t("path_pick:filter.market_basis")}
      </Text>
      <AppButton
        variant={"white"}
        isActive={value === "bidPrice"}
        onClick={() => onChange("bidPrice")}
        width={"100px"}
        chakraProps={{ "aria-pressed": value === "bidPrice" }}
      >
        <Text textStyle={"body-sm-bold"}>
          {t("path_pick:filter.basis_bid")}
        </Text>
      </AppButton>
      <AppButton
        variant={"white"}
        isActive={value === "tradePrice"}
        onClick={() => onChange("tradePrice")}
        width={"100px"}
        chakraProps={{ "aria-pressed": value === "tradePrice" }}
      >
        <Text textStyle={"body-sm-bold"}>
          {t("path_pick:filter.basis_trade")}
        </Text>
      </AppButton>
    </Flex>
  );
}

export default PathPickStartGuideMarketBasisSelector;
